//파이어베이스 가지고 올 때 필요함.
import {db} from "../../firebase";
import {collection,getDocs, addDoc,doc,deleteDoc,updateDoc} from "firebase/firestore";


// 액션 타입
const CREATE = 'word/CREATE'; //댓글 추가
const LOAD ='word/LOAD'; //댓글 파이어 베이스에서 불러오기
const DELETE='word/DELETE'; //댓글 삭제
const UPDATE='word/UPDATE'; //댓글 선택 기능
const MODIFY='word/MODIFY'; //댓글 수정 기능
//초기값 설정
const initialState = {
    list: [],
  };

// Action Creators
export function loadWord(word_list){
    return{type: LOAD, word_list};
};
export function createWord(word){
    return{type: CREATE, word};
}
export function deleteWord(word_index){
    return{type: DELETE, word_index};
};
export function updateWord(id){
    return{type:UPDATE,id};
};
export function modifyWord(word_index,edit){
    return{type:MODIFY,word_index, edit}
};
//미들웨어
export const loadWordFB =() =>{ //데이터 파이어베이스에서 가져오기 
    return async function (dispatch){
        const word_data = await getDocs(collection(db,"word"));
        let word_list =[];
        word_data.forEach((w)=>{
            //word_lsit = [...word_lsit,{...w.data()}]
            
            word_list.push({id:w.id,...w.data()});
        });
        
        dispatch(loadWord(word_list));
    };
};
export const addWordFB =(word) =>{ //추가하기
    return async function(dispatch){
        const docRef =await addDoc(collection(db,"word"),word);
        const word_data ={ id:docRef.id, ...word};
        dispatch(createWord(word_data));
    };
};
export const updateWordFB=(word)=>{ //단어 선택해제 토글기능
  return async function(dispatch,getState){
   // await collection("words").doc(word.id).updateDoc({completed: !word.completed})
    // const docRef = doc(db,"word",word.id); 
    // await updateDoc(docRef,{completed: !word.completed});
     const docRef = doc(db,"word",word.id); //어떤 것을 수정해 줄것인지
    await updateDoc(docRef,{completed: !word.completed});

    //console.log(getState().word)
    dispatch(updateWord(word.id));
   
  };
};
export const modifyWordFB=(id,newWord) =>{ //단어 수정 id값과 새로운 단어를 받아온다.
    return async function(dispatch,getState){
      const docRef=doc(db,"word",id);
      //console.log(id,newWord)
      await updateDoc(docRef,{...newWord})

      const _word_list=getState().word.list; //getstate사용해서 word에 있는 리스트 정도 긁어오고,
      const word_index =_word_list.findIndex((w)=>{
        return w.id === id; //리스트 안에 id가 파라미터 id와 일치하다면 그친구의 idex 가져와
      });
      const newdata = {...newWord, id:id}// 리덕스에도 값 업데이트 해주기!
      // modifyWord 받는 파라미터(업데이트 할 값)를 동일하게 넘겨준다.
      dispatch(modifyWord(word_index,newdata));
      
    };
};
export const deleteWordFB=(word_id) =>{// 삭제하기
    return async function(dispatch,getState){
      if(!word_id){ //만약 워드 아이디가 없다면, 아래구문이 들어가지 못하게 해준다. 또 경고창도 띄워준다.
        window.alert('아이디가 없네요 ? 😜')
        return;
      }
      const docRef=doc(db,"word",word_id); //db word콜렉션 가져오고, Id도 가져온다.
      await deleteDoc(docRef); //어떤 도큐먼트 지워줄것인지.

      const _word_list = getState().word.list; //getstate사용해서 word에 있는 리스트 정도 긁어오고,
      const word_index = _word_list.findIndex((w)=>{
        return w.id === word_id; //리스트 안에 id가 파라미터 id와 일치하다면 그친구의 idex 가져와
      });
      dispatch(deleteWord(word_index)); //일치한 id는 삭제해 !
    };
};
// Reducer
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
      case "word/LOAD": {
        return { list: action.word_list };
      }
      case "word/CREATE": {
        const new_word = [ action.word, ...state.list]; // 순서 바꿔서 최근 word가 앞에 붙게 !!
        return { list: new_word };
      }
      case "word/UPDATE":{
        const new_word_list = state.list.map((word) => 
        word.id === action.id ? { ...word, completed: !word.completed } : word
        );
      // console.log(new_word_list); //토글기능이 잘 되고 있는지 확인차 콘솔로 찍어보기 !!
      return {
        ...state,
        list: new_word_list,
      };
  };
      case "word/MODIFY":{
          const new_word_list = state.list.map((l,idx) => {
            if(parseInt(action.word_index)===idx){
              return{...l,...action.edit};
            }else{
              return l;
            }
          });
          return{list: new_word_list}
      };
      case "word/DELETE":{
        const new_word_list = state.list.filter((l,idx)=>{
          return parseInt(action.word_index) !== idx;
        });
        return {list :new_word_list}
      };
      default:
        return state;
    };
  };